// angular
// 	.module("HeroPRO")
// 	.directive('hpNotificationMenu', notificationMenuDirective);

export default function notificationMenuDirective() {
    return {
        restrict: 'E',
        controller: 'NotificationMenuController',
        controllerAs: 'notificationMenu',
        bindToController: true,
        scope: {
            notifications: '=',
        },
        templateUrl: 'app/notificationCenter/modal/notificationMenu/notificationMenu.html',
        link,
    };

    function link() {

    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/notificationMenu/notificationMenuDirective.js